import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import * as Tooltip from '@radix-ui/react-tooltip';

import { selectIsSidebarCollapsed } from '../../../../redux/main/main.selectors';
import { toggleSidebarCollapse } from '../../../../redux/main/main.actions';


import { useShortKeysNavigation } from '../../../../hooks/useShortKeysNavigation';

import '../../MainApp.scss';

const Header = ({ title = '', subtitle = '', children }) => {
    const dispatch = useDispatch();
    const isSidebarCollapsed = useSelector(selectIsSidebarCollapsed);

    const { map: shortKeysMap } = useShortKeysNavigation();


    const handleToggleSidebar = () => {
        dispatch(toggleSidebarCollapse(!isSidebarCollapsed));
    };

    return (
        <div className='dash-main-header'>

            <div className='dash-main-header-left'>
                <div className="dash-main-header-title">
                    <Tooltip.Root ignoreNonKeyboardFocus delayDuration={1000} disableHoverableContent>
                        <Tooltip.Trigger asChild>
                            <button
                                className='dash-main-header-sidebar-toggle'
                                onClick={handleToggleSidebar}
                                aria-label={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                    <line x1="9" y1="3" x2="9" y2="21"></line>
                                </svg>
                            </button>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                            <Tooltip.Content
                                className="tooltip-content tooltip-controls tooltip-sidebar"
                                side="right"
                                align="center"
                                sideOffset={10}
                            >
                                <span>{!isSidebarCollapsed ? 'Hide' : 'Show'}</span>
                                <span className="tooltip-shortcut">
                                    {shortKeysMap?.CTRL} + B</span>
                            </Tooltip.Content>
                        </Tooltip.Portal>
                    </Tooltip.Root>
                </div>
            </div>
            <div className='dash-main-header-right'>
                {children}
            </div>

        </div >
    );
};

export default Header;
